import { Flex, Grid, ModalFooter, useToast } from "@chakra-ui/react";
import { ButtonCustom } from "../../form/controls/form.button";
import { Modal } from "../Modal";
import { useEffect, useState } from "react";
import { successToast } from "../../../constants/toast.constants";
import { Loading } from "../../shared/Loading";
import { DropdownInput } from "../../form/controls/dropdown.input";
import { companyService } from "../../../service/company/company.service";
import { jobService } from "../../../service/job/job.service";
import { userService } from "../../../service/user/user.service";
import { companyUserService } from "../../../service/company/company-user.service";
import { Region } from "../../../models/enum/region.enum";
import { TextAreaInput } from "../../form/controls/text-area.input";

export const AddInternalJobModal = ({ isOpen, onClose, onSubmit }) => {
  const toast = useToast();

  const [formState, setFormState] = useState(initialState as any);
  const [loading, setLoading] = useState(false);
  const [companyDropdown, setCompanyDropdown] = useState([] as any);
  const [userDropdown, setUserDropdown] = useState([] as any);
  const [adminUserDropdown, setAdminUserDropdown] = useState([] as any);

  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  const onInputChange = (event: any) => {
    let { name, value } = event.target;

    if (value === "") value = null;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const onCompanyChange = (event: any) => {
    let { value } = event.target;
    setSelectedCompanyId(value);
    onInputChange(event);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    await jobService
      .post(formState)
      .then(() => {
        toast(successToast("Job added successfully."));
        handleClose();
        onSubmit();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setFormState(initialState);
    onClose();
  };

  const init = async () => {
    const dropdown = await companyService.getListForDropdown();
    setCompanyDropdown(dropdown);

    await initAdminUserDropdown();
  };

  const setCompanyUsers = async () => {
    if (selectedCompanyId) {
      const users = await companyUserService.getUsers(selectedCompanyId);
      let obj = {};

      users.forEach((user) => {
        if (!user.deleted) {
          obj[user.id] = `${user.firstName} ${user.lastName} <${user.email}>`;
        }
      });

      setUserDropdown(obj);
    }
  };

  const initAdminUserDropdown = async () => {
    const users = await userService.getUsers();
    let obj = {};

    users
      .filter((x) => !x.deleted)
      .forEach((user) => {
        obj[user.id] = `${user.email}`;
      });

    setAdminUserDropdown(obj);
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setCompanyUsers();
  }, [selectedCompanyId]);

  return (
    <Modal
      isOpen={isOpen}
      header="Add a job"
      description="Internal jobs will only display inventory sourced from integrations (only Kandji is supported). You DO NOT need to manually create an internal job - syncing with Kandji will automatically create the job for the client."
      onClose={handleClose}
      width="600px"
    >
      <Loading loading={loading} fill ignoreDelay />
      <form onSubmit={handleSubmit}>
        <Flex flexDir="column" gap="12px">
          <Grid templateColumns="repeat(2, 1fr)" gap={2} rowGap={4}>
            <DropdownInput
              required
              name="companyId"
              title="Company"
              options={companyDropdown}
              onChange={onCompanyChange}
            />
            <DropdownInput
              required
              name="region"
              title="Region"
              options={Region}
              defaultValue={Region.AU}
              onChange={onInputChange}
            />
            <DropdownInput
              name="contactUserId"
              title="Contact user"
              options={userDropdown}
              onChange={onInputChange}
            />
            <DropdownInput
              name="assignedAdminId"
              title="ZOLO Champion"
              options={adminUserDropdown}
              onChange={onInputChange}
            />
          </Grid>
          <TextAreaInput
            title="Additional info"
            name="notes"
            onChange={onInputChange}
          />

          <ModalFooter>
            <Flex gap="12px">
              <ButtonCustom secondary neutral onClick={onClose}>
                Cancel
              </ButtonCustom>
              <ButtonCustom type="submit">Confirm</ButtonCustom>
            </Flex>
          </ModalFooter>
        </Flex>
      </form>
    </Modal>
  );
};

const initialState = {
  status: "INTERNAL",
  startDate: new Date().toISOString(),
};
